import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { callbackPostModel } from '../type/logInModel'
import { configEnum } from '../../../enum/fetchFactoryEnum'
import localStorageEnum from '../../../enum/localStorageEnum'
import Links from '../../../enum/links'
import Loader from '../../../components/loader/Loader'
import { getAuthClient } from '../../../utils/authClient'
import { useCookies } from 'react-cookie'

const CODE = 'code'
const ACCESS_TOKEN: string = 'accessToken'
const ID_TOKEN: string = 'id_token'
const CODE_VERIFIER: string = 'code_verifier'

const CallbackLogin: React.FC = () => {
	const location = useLocation()
	const history = useHistory()
	const setCookie = useCookies([ID_TOKEN])[1]

	const [loading, setLoading] = useState<boolean>(false)

	useEffect(() => {
			const hash = location.hash.split('&')
			const code = hash[0].substr(1).split('=')

			if (code.length > 1 && code[1] && code[0] === CODE) {
				setLoading(true)
				const dataCallback: callbackPostModel = {
					code: code[1],
					code_verifier: localStorage.getItem(CODE_VERIFIER) || ''
				}
				fetch('/api/okta/callback',
					{
						body: JSON.stringify(dataCallback),
						method: configEnum.post
					})
					.then(
						(response: Response) => response.json()
							.then(
								(callbackResponse: any) => {
									const authClient = getAuthClient()
									authClient.tokenManager.add(ACCESS_TOKEN, callbackResponse)
									setCookie(ACCESS_TOKEN, callbackResponse, {
										path: '/',
										domain: JSON.parse(localStorage.getItem('commonUri') || '').cookie_domain || ''
									})

									localStorage.setItem(localStorageEnum.accessToken, JSON.stringify(callbackResponse))
									history.push(Links.accueil)
								}
							)
					)
					.finally(
						() => setLoading(false)
					)
			}
		},
		[location, history, setCookie]
	)
	return (
		<>
			{
				loading && <Loader />
			}
		</>
	)
}

export default CallbackLogin
